import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lazy-loader',
  templateUrl: './lazy-loader.component.html',
  styleUrls: ['./lazy-loader.component.scss']
})
export class LazyLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
